/* eslint-disable import/no-anonymous-default-export */
import ctx from "../../plugins/axios";
export default async (userdata) => {
  return await ctx.post("/specialty_list/incentivized_list", userdata);
};
